import React, { useState } from "react";
import DeviceContext from "../../../service/indentifyDevice";
import { Idevice } from "../../../types/device";
import EdButton from "../../../generic/edButton";
import Toggle from "../../../generic/toggle";
import { useRouteMatch } from "react-router-dom";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import { HHoldMTFGroupBy, HHoldDematGroupBy } from "../../../service/holdings/holdGrpByHelper";
import "../../../../assets/scss/components/generic/filter.scss";

export interface HoldFilterProps {
	data: Array<Array<any>>; // data to be filtered
	defaultToggleState: boolean;
	tglClick: (groupedData: Array<Array<any>>, toggleState: boolean) => void;
}

const HoldFilter: React.FC<HoldFilterProps> = props => {
	const routeParams = useRouteMatch<IHoldRouteParams>();

	// setting state initially as false
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const deviceState: Idevice = DeviceContext();

	const [isToggleOn, setIsToggleOn] = useState(props.defaultToggleState);

	// event to be performed on onSwitchOnOff
	function onSwitchOnOff() {
		// in `isToggleOn, we have the previous state of the toggle button
		// that is why ! operator is used
		props.tglClick(groupData(props.data[0], !isToggleOn), !isToggleOn);

		setIsToggleOn(!isToggleOn);
	}

	/**
	 * This function groups open/pending and other data separately
	 * @param data array of data to be grouped
	 */
	function groupData(data: Array<any>, isToggleOn: boolean): Array<Array<any>> {
		if (isToggleOn) {
			// if toggle is switched on, then group the data
			if (routeParams.url.split("/")[2] === "equity") {
				return HHoldMTFGroupBy(data);
			} else {
				return HHoldDematGroupBy(data);
			}
		} else {
			// if toggle is switched off then return the initial data in 2D form
			return [data];
		}
	}

	function applyFilter() {
		setIsDropdownOpen(false);
	}

	function reset() {
		setIsDropdownOpen(false);
	}

	return (
		<div className={"navigation_dropdown filter hold_filter"}>
			{/* dropdown toggle on click of button */}
			<EdButton
				value={
					<>
						<i className="filter edel-icon-filter btn_icon" />
						{!deviceState.isMobile && <span className="fltr_lbl">Filter</span>}
					</>
				}
				btnTyp="blue-link"
				onClick={() => setIsDropdownOpen(true)}
			/>

			{/* if isDropdownOpen is true the the dropdown will show */}
			{isDropdownOpen && (
				<>
					<div className="dropdown_overlay" onClick={() => reset()} />
					<ul className="dropdown_content">
						{/* toggle the radio button */}
						<li className="dropdown_item">
							<Toggle name="toggle1" isOn={isToggleOn} onChange={onSwitchOnOff}>
								{routeParams.url.indexOf("equity") !== -1 ? "MTF Holdings on top" : "Demat Holdings on top"}
							</Toggle>
						</li>
						{deviceState.isMobile && (
							<div className="fltr_btn">
								<EdButton value="Close" btnTyp="secondary" className="mob_fltr" onClick={() => reset()} />
								<EdButton value=" Apply Filter" btnTyp="primary" className="mob_fltr" onClick={applyFilter} />
							</div>
						)}
					</ul>
				</>
			)}
		</div>
	);
};
export default HoldFilter;
